import { Stack, Flex, Box, Grid, Text } from "@chakra-ui/react";
import backgroundImg from '../../../../../assets/report/background.png';
import { KILOWATT_HOUR } from "../../../../../utils/consts";
import { formatDate } from "../../../../../utils/helpers";
import { ConsumedEnergyIcon } from "../../../../../assets/icons/ConsumedEnergy";
import CostForConsumptionIcon from "../../../../../assets/icons/CostConsumptionIcon";
import logoSvg from '../../../../../assets/logo.svg'
import checkIcon from '../../../../../assets/checkIcon.png'
import { CardPdf } from "../EnergyReportComponents/CardComponentPdf";

type Props = {
    startDate: Date;
    endDate: Date;
    data: any;
    displayData: any;
}

type ThumbnailProps = {
    locations: any
    startDate: Date
    endDate: Date
    data: any
}

export const Thumbnail = ({ data, displayData, startDate, endDate }: Props) => {
    return (
        <Stack
            width="100%"
            height="100%"
            alignItems="center"
            backgroundImage={`url('${backgroundImg}')`}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="left"
        >
            <Flex direction="column" justifyContent="center" alignItems="center" width="100%" height="100%">
                <ThumbnailTitlePage
                    locations={data}
                    data={displayData}
                    startDate={startDate}
                    endDate={endDate}
                />
            </Flex>
        </Stack>
    );
}

export const ThumbnailTitlePage = ({
    locations,
    startDate,
    endDate,
    data,
}: ThumbnailProps) => {
    return (
        <Box
            height="100%"
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            textAlign="center"
            px={8}
            py={10}
            borderRadius="lg"
            overflow="hidden"
        >
            {/* Header */}
            <Stack spacing={4} mb={6}>
                <Text fontSize="40px" fontWeight="700" color="#2C3E50" mt="200px">
                    {`${formatDate(startDate)} - ${formatDate(endDate)}`}
                </Text>
                <Text fontSize="30px" fontWeight="600" color="#2C3E50">
                    Billing Report
                </Text>
            </Stack>

            {/* Locations */}
            <Flex
                wrap="wrap"
                gap={4}
                justifyContent="center"
                mb={10}
                maxWidth="100%"
            >
                {locations?.map((location, index) => (
                    <Flex
                        key={location.id}
                        px={4}
                        py={2}
                        border="2px solid #157FEE"
                        borderRadius="full"
                        bg="#E8EEFD"
                        alignItems="center"
                        gap={2}
                    >
                        <img
                            src={checkIcon}
                            alt="check"
                            style={{ width: "20px", height: "20px" }}
                        />
                        <Text
                            data-location={`locationName${index}`}
                            fontWeight="700"
                            fontSize="16px"
                            color="#157FEE"
                            whiteSpace="nowrap"
                        >
                            {location.title}
                        </Text>
                    </Flex>
                ))}
            </Flex>

            {/* KPI Cards */}
            <Grid
                templateColumns="repeat(2, 1fr)"
                gap={6}
                width="100%"
                maxW="700px"
                py={6}
            >
                <CardPdf
                    title="Total consumed energy"
                    measurementType={KILOWATT_HOUR}
                    value={data.totalConsumption}
                >
                    <ConsumedEnergyIcon boxSize="32px" color="text.secondary" />
                </CardPdf>
                <CardPdf
                    title="Cost for consumed energy"
                    measurementType="лв."
                    value={data.consumptionCost}
                >
                    <CostForConsumptionIcon boxSize="32px" color="text.secondary" />
                </CardPdf>
            </Grid>

            {/* Logo */}
            <Box mt="auto" mb="80px">
                <img src={logoSvg} alt="logo" style={{ width: "150px", height: "20px" }} />
            </Box>
        </Box>
    );
};
